/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';

export namespace AgentDetailsIconWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  agentDetailsIconWrapper: {
    marginRight: 10,
    display: 'flex',
    color: colors.clayPlus3,
    width: 24,
  },
});

export const AgentDetailsIconWrapper: React.FC<AgentDetailsIconWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <span className={css(styles.agentDetailsIconWrapper)} {...htmlProps}>
      {children}
    </span>
  );
};
